export default "__VITE_ASSET__DLvCVrG9__"